import functionRandom from 'mixins/functionRandom'
import ContractingApi from '@/api/contractsApi.js'
const api = new ContractingApi()

export default {
  mixins: [ functionRandom ],
  methods: {
    async createContractAsync(tenderId, organizarCodes) {
      const id = this.$_createGuid()
      this.$notice.info({
        id,
        title: 'Формування договору',
        message: 'Іде формування договору, зачекайте...',
        loading: true
      })
      let res = {}
      try {
        res = await api.createContract(tenderId, organizarCodes)
      } catch (err) {
        this.$notice.update({
          type: 'error',
          message: err.message,
          duration: 10,
          loading: false,
          dangerouslyUseHTMLString: true,
          showClose: true,
          progress: true,
        }, id)
        return
      }
      if (res.data && res.data.createContract.success) {
        this.$notice.update({
          message: res.data.createContract.message,
          duration: 10,
          loading: false,
          dangerouslyUseHTMLString: true,
          showClose: true,
          progress: true,
        }, id)
      } else if (res.data && !res.data.createContract.success) {
        this.$notice.update({
          type: 'error',
          message: res.data.createContract.message,
          duration: 10,
          loading: false,
          dangerouslyUseHTMLString: true,
          showClose: true,
          progress: true,
        }, id)
      } else {
        this.$notice.update({
          type: 'error',
          message: res?.errors?.map(_ => _.message).join('\r\n'),
          duration: 10,
          loading: false,
          dangerouslyUseHTMLString: true,
          showClose: true,
          progress: true,
        }, id)
      }
    }
  }
}
